module.exports = __webpack_public_path__ + "img/D202107_4.a8f90a06.jpg";